export default __webpack_public_path__ + "static/Principle-profil-f0a44e57815282d235a2fb2d46ed894e.png";